export default
    {
        path:'/aboutwe/:id',
        mapPath:'/aboutwe',
        component: require('./index').default,
    }
